function output(str) {
  console.log(str);
}

module.exports = { output };



//////////////////
// WEBPACK FOOTER
// ./output.js
// module id = 2
// module chunks = 0